export default __webpack_public_path__ + "static/gallery_xl_4-ef01d90798d4903cb82fe88ef4ce25a8.jpg";